export default __webpack_public_path__ + "static/media/Commander's Legguards of the Golden Sun.adc47466.jpg";